import { Component, Input, OnInit } from '@angular/core'
import { FormGroup } from '@angular/forms'
import { UnknownParams, ControlElement } from '@app/form-builder/interfaces/form.interface'

import { environment } from '@environments/environment';

@Component({
    selector: 'image-group-element',
    templateUrl: './image-group.component.html',
    host: {
        '[style.display]': '"flex"',
        '[style.justify-content]': '"center"'
    }
})
export class ImageGroupComponent implements OnInit {

    attributes: UnknownParams = {}
    validations: UnknownParams = {}

    @Input() form: FormGroup

    @Input() data: ControlElement

    constructor() {}

    ngOnInit(): void {
        for (var i in this.data.attributes) {
            const attribute = this.data.attributes[i]
            this.attributes[attribute.name] = attribute.value
        }
        for (var i in this.data.validations) {
            const validation = this.data.validations[i]
            this.validations[validation.name] = validation.value
        }
    }

    getImageURL(filename: string) {
        return `${environment.apiUrl}/files/resources/${filename}`
    }
}